import { SvgIcon, type SvgIconProps } from '~/@mid_ui/icons/svgIcon'
import { cn } from '~/shadcn/lib/utils'

export function FilterOffIcon({
  width = 24,
  height = 24,
  className,
  ...props
}: SvgIconProps) {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox="0 0 24 24"
      className={cn('w-6! h-6!', className)}
      {...props}>
      <path
        d="M14.8548 11.5561L13.6074 10.3087L17.7782 5.00033H8.29906L6.54909 3.25036H21.3948L14.8548 11.5561ZM21.1077 23.5817L13.7532 16.2272V20.7503H10.2533V12.7272L0.421875 2.89584L1.65134 1.64844L22.3551 22.3522L21.1077 23.5817Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
